import React from 'react';
import { Button, Icon, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { surfaceCardStyle } from '../misc/pageStyles';

function AccountImportCard({
  from = '/canales',
  prominent = false,
  title = 'Importar cuenta',
  cta = 'Importar cuenta',
  description = 'Conectá Mercado Libre o Tienda Nube e importá sus publicaciones para empezar a operar en Stocky.',
}) {
  return (
    <Segment
      style={{
        ...surfaceCardStyle,
        padding: prominent ? 24 : 20,
        height: '100%',
        ...(prominent
          ? {
              borderColor: '#C4B5FD',
              background: 'linear-gradient(180deg, #FFFFFF 0%, #FAF5FF 100%)',
            }
          : {}),
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 14,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F5EDFF',
          color: '#7C3AED',
          marginBottom: 14,
        }}
        aria-hidden="true"
      >
        <Icon name="download" style={{ margin: 0 }} />
      </div>
      <div style={{ fontSize: prominent ? 22 : 18, fontWeight: 800, marginBottom: 8 }}>{title}</div>
      <div style={{ color: '#6B7280', lineHeight: 1.6, marginBottom: 18 }}>{description}</div>
      <Button
        as={Link}
        to="/newAccount"
        state={{ from }}
        color="violet"
        fluid={prominent}
        basic={!prominent}
      >
        {cta}
        <Icon name="arrow right" style={{ marginLeft: 8, marginRight: 0 }} />
      </Button>
    </Segment>
  );
}

export default AccountImportCard;
